import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import DataLoader from "../../../../ui/template/Data/DataLoader";
import Child from "../../../../ui/template/Children/Child";
import AppConfig from "../../../Controllers/AppConfig";
import Comments from "./Comments";
import Interface from "../../../../ui/template/Interface";
import VideoPlayer from "../../../../ui/template/Video/VideoPlayer";


class   Posts extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;
        this.rowsId=0;
        this.HfunCV=this.funCV.bind(this);
        this.props=props;
    }


    getMediaFile(postId,media){
        let el=null;
        let s1= 'http://mdyaran.ir/membership/post/media/'+postId+'/'+media.id+'.'+media.fileType;
        switch (media.fileType){
            case "jpg":
            case "jpeg":
            case "png":
            case "gif":
                el= <a  href="javascript:void(0)"  data-fancybox="gallery"  data-src={s1}  >
                    <img className="lazyload blur-up img-fluid box shadow-sm border rounded mb-3 w-100"
                         data-src={s1}   src="/images/default.png" alt={media.title} /></a>;
                break;
            case "mp4":
                el= <div className="player1 position-relative d-block w-100">
                    <VideoPlayer poster="/images/poster.jpg" controls={true} sources={[{ src: s1, type: 'video/mp4' }]}  /></div> ;
                break;
            case "webm":
                el= <div className="player1 position-relative d-block w-100">
                    <VideoPlayer poster="/images/poster.jpg" controls={true} sources={[{ src: s1, type: 'video/webm' }]}  /></div>  ;
                break;
            case "ogg":
                el= <div className="player1 position-relative d-block w-100">
                    <VideoPlayer   poster="/images/poster.jpg" controls={true} sources={[{ src: s1, type: 'video/ogg' }]}  /></div>  ;
                break;
            case "wave":
                el= <VideoPlayer controls={true} sources={[{ src: s1, type: 'audio/vnd.wave' }]}  /> ;
                break;
            case "wav":
                el= <VideoPlayer controls={true} sources={[{ src: s1, type: 'audio/wav' }]}  /> ;
                break;
            case "mp3":
                el= <VideoPlayer controls={true} sources={[{ src: s1, type: 'audio/mp3' }]}  /> ;
                break;
        }
        return el;
    }

    funCV(data,ts,recordKey,selectFun=null){
        let rows=[];
        let l=data.length;
        let postId=0;
        for (let i=0;i<l;i++){
            postId=data[i].id;
            this.rowsId++;
            let s1='http://mdyaran.ir/membership/'+data[i].membershipId+'/picture';
             let lFiles=0;
            if(data[i].files!=null){
               if(Interface.isArray(data[i].files)){
                    lFiles=data[i].files.length;
                }
            }
            let dF=null;
            if(lFiles>0){
                switch (lFiles){
                    case 1:
                        let e1=this.getMediaFile(postId,data[i].files[0]);
                        dF=<><div className="d-block w-100 mb-2 mt-2" >{e1}</div>
                            <p className="mb-0">{data[i].text}</p></>;
                        break;
                    case 2:
                        let e10=this.getMediaFile(postId,data[i].files[0]);
                        let e11=this.getMediaFile(postId,data[i].files[1]);
                        dF=<><div className="row w-100 mb-2 mt-2" >
                            <div className="col-md-6 mb-2 mb-md-0 " >{e10}</div>
                            <div className="col-md-6   " >{e11}</div>
                            </div> <p className="mb-0">{data[i].text}</p></>;
                        break;
                    case 3:
                        let e20=this.getMediaFile(postId,data[i].files[0]);
                        let e21=this.getMediaFile(postId,data[i].files[1]);
                        let e22=this.getMediaFile(postId,data[i].files[2]);
                        dF=<>  <div className="d-block w-100   mt-2" >{e20}</div>
                            <div className="row w-100 mb-2 mt-2" >
                            <div className="col-md-6 mb-2 mb-md-0 " >{e21}</div>
                            <div className="col-md-6   " >{e22}</div>
                        </div> <p className="mb-0">{data[i].text}</p></>;
                        break;
                    case 4:
                        let e30=this.getMediaFile(postId,data[i].files[0]);
                        let e31=this.getMediaFile(postId,data[i].files[1]);
                        let e32=this.getMediaFile(postId,data[i].files[2]);
                        let e33=this.getMediaFile(postId,data[i].files[3]);
                        dF=<>  <div className="row w-100   mt-2" >
                                <div className="col-md-6 mb-2 mb-md-0 " >{e30}</div>
                                <div className="col-md-6   " >{e31}</div>
                                </div>  <div className="row w-100 mb-2 mt-2" >
                                <div className="col-md-6 mb-2 mb-md-0 " >{e32}</div>
                                <div className="col-md-6   " >{e33}</div>
                            </div> <p className="mb-0">{data[i].text}</p></>;
                        break;
                    case 5:
                        let e40=this.getMediaFile(postId,data[i].files[0]);
                        let e41=this.getMediaFile(postId,data[i].files[1]);
                        let e42=this.getMediaFile(postId,data[i].files[2]);
                        let e43=this.getMediaFile(postId,data[i].files[3]);
                        let e44=this.getMediaFile(postId,data[i].files[4]);
                        dF=<><div className="d-block w-100   mt-2" >{e40}</div>
                            <div className="row w-100   mt-2" >
                                <div className="col-md-6 mb-2 mb-md-0 " >{e41}</div>
                                <div className="col-md-6   " >{e42}</div>
                            </div>  <div className="row w-100 mb-2 mt-2" >
                            <div className="col-md-6 mb-2 mb-md-0 " >{e43}</div>
                            <div className="col-md-6   " >{e44}</div>
                        </div> <p className="mb-0">{data[i].text}</p></>;
                        break;
                }
            }else{
                dF=<p className="mb-0">{data[i].text}</p>;
            }

            let el=  <div key={this.rowsId} className="box shadow-sm border rounded bg-white mb-3 osahan-post">
                        <div className="p-3 d-flex align-items-center border-bottom osahan-post-header">
                            <div className="dropdown-list-image mr-3">
                                <img  src="/images/avatar.jpg" data-src={s1} alt="" className="lazyload blur-up img-fluid rounded-circle mw150"/>
                                <div className="status-indicator bg-success" />
                            </div>
                            <div className="font-weight-bold">
                                <div className="text-truncate">
                                    {data[i].usernameMember}
                                </div>
                                <div className="small text-gray-500">
                                    {data[i].usernameMember}
                                </div>
                            </div>
                            <span className="ml-auto small">  {data[i].createdAt} </span>
                        </div>
                        <div className="p-3 border-bottom osahan-post-body">
                            {dF}
                        </div>
                        <Comments postId={data[i].id} />
                    </div>    ;
            rows.push(el);
        }
        ts.cv=<>{rows}</>;
    }



   

    render() {

        return (
            <DataLoader ref={this.table1} scope="route" name="post" classNameLoader="dataloader2"
                        baseUrl={AppConfig.base_url} orderColumn={1} orderDir={2}
                        srcName="post" getBoxItem={ this.HgetBoxItem} selectable={false}
                        funCustomVeiw={ this.HfunCV} isCustomVeiw={true} className="" isHeader={false}
                        queryFields="id,state,createdAt,text,usernameMember,membershipId,files{id,fileType,title}">
                <Child type="navbar">

                </Child>
                <Child type="links">

                </Child>
            </DataLoader>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Posts.contextType = MCbrowser;

export default Posts;
